import { call, takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getSelectedItem } from '../selectors'
import { IItem } from '../store/timeline.types'
import { TimelineConstants } from '../store/timeline.constants'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { setState } from '../../intubation/store/intubation.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setIntubationProcedureItem() {
  const selectedItem: IItem = yield select(getSelectedItem)
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (pcrID) {
    try {
      if (selectedItem) {
        const pcrDocsService = new PcrDocsService(serviceId)
        const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
        const isState = pcrDoc.patient.intubationStateList?.find((isState) => {
          if (selectedItem.labelHeader) {
            isState.time = selectedItem?.labelHeader
          }
          return isState.key === selectedItem.key
        })
        yield put(setState(isState))
      }
    } catch (e) {
      yield put(throwPcrException(`setIntubationProcedureItem() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setIntubationProcedureItemSaga() {
  yield takeLatest([TimelineConstants.SET_INTUBATION_PROCEDURE_ITEM], performWithMutexHOG, setIntubationProcedureItem)
}
